<!--
  @Author: The Jin
  @Date: 2025-05-28 13:40
  @FilePath: src\views\sop\executionResPopup.vue
  @Description: 执行结果
  @LastEditors:  The Jin
  @LastEditTime: 2025-05-28
  @LastDescription: 
 -->
<template>
    <el-dialog title="任务执行情况" @close="closeDialog" :visible.sync="dialogVisibleM" :modal-append-to-body="false" width="70%"
        class="add-label-dialog" :close-on-click-modal="false">
        <div class="dialog-container">
            <div class="status-row" v-loading="statusLoading">
                <div class="status-item">
                    <h3>执行数</h3>
                    <span>{{ statusObj.finishNum }}</span>
                </div>
                <div class="status-item">
                    <h3>未执行数</h3>
                    <span>{{ statusObj.unexecuteNum }}</span>
                </div>
            </div>
            <div class="cus-chat-supervise-search">
                <el-form :inline="true" style="height: 100%;" label-position="left">
                    <el-form-item label="群名称" class="el-form-item">
                        <el-input v-model="formInline.groupChatName" style="width: 120px;" size="mini" clearable
                            @change="selectBindStatus" />
                    </el-form-item>
                    <el-form-item label="群主" class="el-form-item">
                        <el-input v-model="formInline.userName" style="width: 120px;" size="mini" clearable
                            @change="selectBindStatus" />
                    </el-form-item>
                    <el-form-item label="执行日期" class="el-form-item">
                        <el-date-picker style="width: 150px;" :picker-options="disabledBeforeDate" v-model="sendTimeM"
                            size="mini" type="date" placeholder="选择日期" @change="selectBindStatus">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="执行状态" class="el-form-item">
                        <el-select style="width: 120px;" v-model="formInline.status" size="mini" placeholder="请选择"
                            @change="selectBindStatus">
                            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div>
                    <el-tooltip class="item" effect="dark" :content="disabledAgain ? '24小时内不能超过3次提醒' : ''"
                        placement="top-start" :disabled="!disabledAgain">
                        <el-button type="primary" size="mini" @click="againRemind" v-loading="loadingBtn"
                            :disabled="disabledAgain">一键再次提醒</el-button>
                    </el-tooltip>
                </div>
            </div>
            <div class="table-row" ref="tableWrapper">
                <el-table size="small" :data="tableData" fit highlight-current-row align="center" v-loading="tableLoading"
                    :header-cell-style="{ background: '#eef1f6' }" ref="cusChatTable" :height="tableHeight">
                    <el-table-column label="序号" width="80">
                        <template slot-scope="scope">
                            {{ getGlobalIndex(scope.$index) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="groupChatName" label="群名称" show-overflow-tooltip align="center">
                    </el-table-column>
                    <el-table-column prop="userName" label="群主" align="center">
                    </el-table-column>
                    <el-table-column prop="sendTime" label="执行日期" align="center">
                    </el-table-column>
                    <el-table-column prop="status" label="执行状态" align="center">
                    </el-table-column>
                    <el-table-column prop="operation" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" link size="mini" @click="see(scope.row)">查看聊天记录</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <Pagination class="Pagination-row" v-bind:childMsg="pageparm" :pageSizes="pageSizes" @callBack="callBack">
            </Pagination>
        </div>
    </el-dialog>
</template>
<script>
import dayjs from "dayjs";
import {
    executeStaticApi, getRemindTimeFlagApi,
    executeInfoApi, remindAgainApi
} from "@/api/groupSop.js";
export default {
    components: {
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        row: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            currentRow: null,
            tableData: [],
            options: [{
                value: '',
                label: '全部'
            }, {
                value: 0,
                label: '执行中'
            }, {
                value: 1,
                label: '已执行'
            }

            ],
            pageparm: {
                pageNum: 1,
                pageSize: 20,
                total: 0,
            },
            formInline: {
                total: 0,
                page: 1,
                size: 20,
                groupChatName: "",
                userName: "",
                sendTime: "",
                status: "",
            },
            sendTimeM: null,
            pageSizes: [20, 50, 100, 200, 500], //分页条数
            date: null,
            searchTagItem: [],
            tagList: [],
            cusChatTable: null,

            statusObj: {
                /**未执行群聊数 */
                unexecuteNum: null,
                /**执行群聊数 */
                finishNum: null,
            },
            showViewChatHistory: false,
            statusLoading: false,
            tableLoading: false,
            loadingBtn: false,
            tableHeight: 200,
            tableWrapper: null,
            disabledBeforeDate: {
                disabledDate: (time) => {
                    // 将指定日期转换为时间戳
                    const specificDate = new Date().getTime();
                    // 将选择的时间转换为时间戳
                    const targetDate = new Date(time).getTime();
                    console.log('disabledBeforeDate', targetDate, specificDate);
                    // 如果选择的时间大于或等于指定日期，则禁用该日期
                    return targetDate > specificDate ? true : false
                }
            },
            disabledAgain: false,
        }
    },

    watch: {
        dialogVisible: {
            handler(newVal, oldVal) {
                console.log("监听 dialogVisible", newVal);
                this.dialogVisibleM = newVal
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.$nextTick(() => {
            // 动态计算父容器高度
            this.tableHeight = this.$refs.tableWrapper.clientHeight;
        });
        // 窗口变化时更新（可选）
        window.addEventListener('resize', this.calculateHeight);
    },

    async created() {
        this.getList(this.formInline);
        this.getStatus()
        this.againStatus()
    },
    methods: {
        getGlobalIndex(index) {
            return (this.formInline.page - 1) * this.formInline.size + index + 1;
        },
        callBack(parm) {
            this.formInline.page = parm.currentPage;
            this.formInline.size = parm.pageSize;
            this.getList(this.formInline);
        },
        selectBindStatus() {
            this.formInline.page = 1;
            if (this.sendTimeM != null) {
                this.formInline.sendTime = dayjs(this.sendTimeM).format(
                    "YYYY-MM-DD HH:mm:ss"
                );
            } else {
                this.formInline.sendTime = null
            }
            this.getList(this.formInline);
        },
        /**获取表格数据 */
        getList(parameter) {
            this.tableLoading = true
            executeInfoApi({ id: this.row.id, ...parameter }, localStorage.getItem("Authorization")).then((res) => {
                this.tableLoading = false
                if (res.error.code == 200) {
                    console.log('获取表格数据', res);
                    if (res.data.records.length > 0) {
                        // 处理执行日期
                        res.data.records.forEach(v => {
                            if (v.sendTime) {
                                v.sendTime = (v.sendTime.split(' '))[0]
                            }
                        })
                        this.tableData = res.data.records;
                        this.pageparm.total = Number(res.data.total || 0);
                    } else {
                        this.tableData = [];
                        this.pageparm.total = 0
                    }
                }
            }).catch(() => {
                this.tableLoading = false
            });
        },
        /**获取统计数据 */
        getStatus() {
            this.statusLoading = true
            executeStaticApi({ id: this.row.id }, localStorage.getItem("Authorization")).then((res) => {
                this.statusLoading = false
                if (res.error.code == 200) {
                    this.statusObj.finishNum = res.data?.finishNum || 0
                    this.statusObj.unexecuteNum = res.data?.unexecuteNum || 0
                    console.log('executeStaticApi', res);
                }
            }).catch(() => {
                this.statusLoading = false
            });
        },
        /**获取一件提醒 */
        againStatus(isSend) {
            this.loadingBtn = true
            getRemindTimeFlagApi({ taskId: this.row.id }, localStorage.getItem("Authorization")).then((res) => {
                this.loadingBtn = false
                if (res.error.code == 200) {
                    this.disabledAgain = !res.data
                } else {
                    this.disabledAgain = true
                }
                if (isSend) {
                    this.$message.success("提醒成功！");
                }
            }).catch(() => {
                if (isSend) {
                    this.$message.success("提醒成功！");
                }
                this.disabledAgain = true
                this.loadingBtn = false
            });
        },

        againRemind() {
            if (this.disabledAgain) {
                return this.$message.warning("24小时内不能超过3次提醒");
            }
            if (this.loadingBtn) return
            this.loadingBtn = true
            remindAgainApi({ taskId: this.row.id }, localStorage.getItem("Authorization")).then((res) => {
                this.loadingBtn = false
                if (res.error.code == 200) {
                    this.againStatus(true)
                }
            }).catch(() => {
                this.loadingBtn = false
            });
        },

        /**关闭 */
        closeDialog(reset) {
            this.$emit('update:dialogVisible', false)
        },
        /**关闭 */
        see(row) {
            // this.currentRow = row
            // this.showViewChatHistory = true
            this.$emit('openViewPopup', row)

        },
    },
};
</script>
<style lang="scss" scoped>
.dialog-container {
    display: flex;
    flex-direction: column;
    // height: 60vh;

    .status-row {
        height: 100px;
        display: flex;
        gap: 80px;
        margin-bottom: 20px;
        margin-left: 10px;

        .status-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 14px;

            h3 {
                margin: 0;
                padding: 0;
                color: #ccc;
            }

            span {
                font-size: 40px;
                font-weight: 700;
                color: #000;
            }
        }
    }

    .cus-chat-supervise-search {
        // height: 40px;
        line-height: 40px;
        // max-height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        :deep(.el-form-item__label) {
            margin-right: 6px !important;
        }

        .el-form-item {
            margin-bottom: 6px !important;
        }

    }

    .table-row {
        height: calc(60vh - 200px);
        // flex: 1;
        // min-height: 200px;
    }

    .Pagination-row {
        height: 40px;
        text-align: right;
    }
}
</style>
  